import set from 'lodash.set';
import { useState } from 'react';

const useOnChangeState = setState => {
	const [ isChanged, setChanged ] = useState(false);

	const onChange = async (field, value) => await setState(prev => {
		// console.log(field, value);
		let data = JSON.parse(JSON.stringify(prev));
		
		if (Array.isArray(field)) {
			field.forEach(i => set.apply(this, [ data, ...i ]));
		} else if (typeof field === 'function') {
			const result = field(data);
			if (result !== undefined) data = result;
		} else if (value === undefined) {
			return field;
		} else {
			set(data, field, value);
		}
			
		if (!isChanged) setChanged(true);
		
		return data;
		// if (Array.isArray(data)) return [ ...data ];
		// return { ...data };
	});

	const onMassChange = values => setState(prev => {
		const data = JSON.parse(JSON.stringify(prev));
		values.forEach(i => set(data, i.field, i.value));
		if (!isChanged) setChanged(true);
		return { ...data };
	});

	return {
		onChange,
		onMassChange,
		isChanged,
		setChanged,
	};
};

export default useOnChangeState;